import React, { useState } from "react";
import AdminNav from "./AdminNav";
import AdminFooter from "./AdminFooter";
import { Context } from "../../utils/context";
import { useLocation } from "@reach/router"; // Correctly handles location in Gatsby

const AdminLayout = ({ children }) => {
  const location = useLocation(); // Get the current path dynamically
  const [activeItem, setActiveItem] = useState(null);

  const loc = location.pathname;
  
  return (
    <div className="layout-container">
      
      {loc != "/admin/hr-admin-login/" && (
        <header className="layout-header">
          <AdminNav setActiveItem={setActiveItem} activeItem={activeItem} />
        </header>
      )}

      <main className="layout-main">
        <Context.Provider value={setActiveItem}>{children}</Context.Provider>
      </main>

  
      {loc != "/admin/hr-admin-login/" && (
        <footer className="layout-footer">
          <AdminFooter setActiveItem={setActiveItem} activeItem={activeItem} />
        </footer>
      )}
    </div>
  );
};

export default AdminLayout;
